import React from 'react'
import { Popover, Transition } from '@headlessui/react'
import { QuestionMarkCircleIcon } from '@heroicons/react/outline'

//image
import ConExamplePng from '../../../../../../images/importContactsV2.png';

function ImportExampleV2() {
    return (
        <div>
             <Popover className="absolute">
                <Popover.Button>
                    <QuestionMarkCircleIcon className="h-5 ml-2" />
                </Popover.Button>
                <Transition
                    enter="transition duration-100 ease-out"
                    enterFrom="transform scale-95 opacity-0"
                    enterTo="transform scale-100 opacity-100"
                    leave="transition duration-75 ease-out"
                    leaveFrom="transform scale-100 opacity-100"
                    leaveTo="transform scale-95 opacity-0"
                >
                    <Popover.Panel className="-ml-2 absolute z-10 bg-white rounded-lg shadows p-2 border-2 border-gray-300 w-80">
                        <div>
                            <b>Example</b>
                            <div className="mb-4 flex-shrink-0 sm:mb-0 sm:mr-4">
                                <img src={ConExamplePng} alt="examples" width='400px' height='400px'/>
                            </div>
                        </div>
                    </Popover.Panel>
                </Transition>
                </Popover>
        </div>
    )
}

export default ImportExampleV2
